// Shopify AJAX Modal System
(function() {
  'use strict';
  
  // Create modal HTML structure
  function createModal() {
    if (document.getElementById('ajax-modal-overlay')) return;
    
    var modalHTML = '<div id="ajax-modal-overlay" class="ajax-modal-overlay">' +
      '<div class="ajax-modal">' +
        '<div class="ajax-modal-header">' +
          '<h2 class="ajax-modal-title">Loading...</h2>' +
          '<button class="ajax-modal-close" type="button">&times;</button>' +
        '</div>' +
        '<div class="ajax-modal-content">' +
          '<div class="ajax-modal-loading">' +
            '<div class="ajax-modal-spinner"></div>' +
            'Loading content...' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }
  
  // Show modal
  function showModal() {
    var overlay = document.getElementById('ajax-modal-overlay');
    if (overlay) {
      document.body.style.overflow = 'hidden';
      overlay.classList.add('active');
    }
  }
  
  // Hide modal
  function hideModal() {
    var overlay = document.getElementById('ajax-modal-overlay');
    if (overlay) {
      document.body.style.overflow = '';
      overlay.classList.remove('active');
    }
  }
  
  // Set modal content
  function setModalContent(title, content) {
    var titleElement = document.querySelector('.ajax-modal-title');
    var contentElement = document.querySelector('.ajax-modal-content');
    
    if (titleElement) titleElement.textContent = title;
    if (contentElement) contentElement.innerHTML = content;
  }
  
  // Set loading state
  function setLoadingState() {
    setModalContent('Loading...', 
      '<div class="ajax-modal-loading">' +
        '<div class="ajax-modal-spinner"></div>' +
        'Loading content...' +
      '</div>'
    );
  }
  
  // Set error state
  function setErrorState(message) {
    setModalContent('Error', 
      '<div class="ajax-modal-error">' +
        '<p>Failed to load content: ' + message + '</p>' +
        '<p>Please try again later.</p>' +
      '</div>'
    );
  }
  
  // Fetch content from URL
  function fetchContent(url) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(xhr.responseText);
          } else {
            reject(new Error('HTTP ' + xhr.status + ': ' + xhr.statusText));
          }
        }
      };
      xhr.onerror = function() {
        reject(new Error('Network error'));
      };
      xhr.send();
    });
  }
  
  // Extract content from HTML
  function extractMainContent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    
    // Try to find #MainContent first
    var content = doc.querySelector('#MainContent');
    
    // Fallback to other common selectors if #MainContent not found
    if (!content) {
      content = doc.querySelector('main') || 
                doc.querySelector('.main-content') || 
                doc.querySelector('#main') ||
                doc.querySelector('.content');
    }
    
    // If still no content found, use body
    if (!content) {
      content = doc.body;
    }
    
    // Get page title
    var title = doc.title || 'Content';
    
    return {
      title: title,
      content: content ? content.innerHTML : '<p>No content found.</p>'
    };
  }
  
  // Handle link click
  function handleLinkClick(event, link) {
    event.preventDefault();
    
    var url = link.href;
    if (!url) return;
    
    console.log('Opening modal for URL:', url);
    
    // Show modal with loading state
    setLoadingState();
    showModal();
    
    // Fetch the page content
    fetchContent(url)
      .then(function(html) {
        // Extract the main content
        var extracted = extractMainContent(html);
        
        // Update modal with content
        setModalContent(extracted.title, extracted.content);
      })
      .catch(function(error) {
        console.error('Error loading content:', error);
        setErrorState(error.message);
      });
  }
  
  // Initialize modal system
  function init() {
    console.log('Initializing AJAX Modal...');
    
    // Create modal
    createModal();
    
    // Set up event listeners
    document.addEventListener('click', function(event) {
      // Handle clicks on links inside .product__tax
      var link = event.target.closest('.product__tax a[href]');
      if (link) {
        console.log('Product tax link clicked:', link.href);
        // Only handle internal links (same domain or relative)
        try {
          var url = new URL(link.href, window.location.origin);
          if (url.origin === window.location.origin) {
            handleLinkClick(event, link);
          }
        } catch (e) {
          // Handle relative URLs
          if (link.href.indexOf('http') !== 0) {
            handleLinkClick(event, link);
          }
        }
        return;
      }
      
      // Handle modal close button clicks
      if (event.target.matches('.ajax-modal-close')) {
        hideModal();
        return;
      }
      
      // Handle overlay clicks (close modal)
      if (event.target.matches('#ajax-modal-overlay')) {
        hideModal();
        return;
      }
    });
    
    // Handle escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        hideModal();
      }
    });
    
    console.log('AJAX Modal initialized successfully');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();